import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
    Box,
    Button,
    Collapse,
    Divider,
    Drawer,
    IconButton,
    ListItem,
    Tooltip,
    Typography,
    useTheme
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";
import {ChevronDown, ChevronRight, HelpCircle} from "lucide-react";
import logoSrc from "../../res/imgs/logo_black.svg";
import {useNavigate} from "react-router-dom";


export const SideBar = ({
                            openParent,
                            itemsMenu,
                            companyName,
                            onHandleDrawerToggle,
                            onHandleMenuOpen,
                            onHandleMenuClose,
                            onToggleSubMenu,
                        }) => {

    const theme = useTheme();
    const navigate = useNavigate();
    const handleDrawerToggle = () => {
        onHandleDrawerToggle(!openParent);
    };

    const handleMenuOpen = (id) => {
        onHandleMenuOpen(id);
    }

    const toggleSubMenu = (id) => onToggleSubMenu(id);
    const handleItemClick = (item) => {
        handleMenuOpen(item.id);
        item.onClick?.();
    };

    const drawerWidth = 260;
    const collapsedWidth = 72;


    const drawer = (
        <Box
            sx={{
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: openParent ? 3 : 1.5,
                    justifyContent: openParent ? 'space-between' : 'center',
                    height: 64,
                    minHeight: 64,
                }}
            >
                {openParent ? (
                    <Box sx={{display: 'flex', alignItems: 'center', overflow: 'hidden'}}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 40,
                                height: 40,
                                borderRadius: '0%',
                                backgroundColor: 'transparent',
                                color: 'transparent',
                                marginRight: 1.5,
                                flexShrink: 0,
                            }}
                            onClick={() => navigate('/')}
                        >
                            <Box
                                component="img"
                                src={logoSrc}
                                alt={`${companyName} logo`}
                                onClick={() => navigate('/')}
                                sx={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', cursor: 'pointer' }}
                            />
                        </Box>
                        <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            fontWeight={700}
                            onClick={() => navigate('/')}
                            sx={{
                                opacity: 1,
                                width: 'auto',
                                transition: theme.transitions.create(['opacity', 'width'], {
                                    duration: theme.transitions.duration.shortest,
                                }),
                                cursor: 'pointer',
                            }}
                        >
                            {companyName}
                        </Typography>
                    </Box>
                ) : null}
                <Tooltip title={openParent ? "Minimizar menu" : "Expandir menu"}>
                    <IconButton onClick={handleDrawerToggle}>
                        <MenuIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            <Divider />
            <List>
                {itemsMenu.map(item => !item.listItems ? (
                            <ListItemButton
                                key={item.id}
                                selected={item.selected}
                                disabled={item.disabled}
                                onClick={() => handleItemClick(item)}
                                sx={{
                                    minHeight: 48,
                                    justifyContent: openParent ? 'initial' : 'center',
                                    px: openParent ? 2.5 : 0,
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: openParent ? 40 : 'auto',
                                        width: openParent ? 'auto' : '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        color: item.selected ? theme.palette.primary.main : 'inherit'
                                    }}
                                >
                                    <Box sx={{width: 24, height: 24, display: 'grid', placeItems: 'center'}}>
                                        {item.icon}
                                    </Box>
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.label}
                                    sx={{
                                        opacity: openParent ? 1 : 0,
                                        width: openParent ? 'auto' : 0,
                                        display: openParent ? 'block' : 'none',
                                        transition: 'opacity 0.2s, width 0.2s',
                                    }}
                                />
                            </ListItemButton>
                        ):
                        (
                            <Box key={item.id}>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        selected={item.selected}
                                        disabled={item.disabled}
                                        onClick={() => {
                                            handleMenuOpen(item.id);
                                            toggleSubMenu(item.id);
                                        }}
                                        sx={{
                                            minHeight: 48,
                                            justifyContent: openParent ? 'initial' : 'center',
                                            px: openParent ? 2.5 : 0,
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                minWidth: openParent ? 40 : 'auto',
                                                width: openParent ? 'auto' : '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                color: item.selected ? theme.palette.primary.main : 'inherit'
                                            }}
                                        >
                                            <Box sx={{width: 24, height: 24, display: 'grid', placeItems: 'center'}}>
                                                {item.icon}
                                            </Box>
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={item.label}
                                            sx={{
                                                opacity: openParent ? 1 : 0,
                                                width: openParent ? 'auto' : 0,
                                                display: openParent ? 'block' : 'none',
                                                transition: 'opacity 0.2s, width 0.2s',
                                            }}
                                        />
                                        {openParent ? (
                                            <Box sx={{display: 'flex', ml: 1}}>
                                                {item.expanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                                            </Box>
                                        ) : null}
                                    </ListItemButton>
                                </ListItem>

                                <Collapse in={openParent && item.expanded} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {item.listItems.map(children => (
                                            <ListItemButton
                                                key={children.id}
                                                selected={children.selected}
                                                disabled={children.disabled}
                                                onClick={() => handleItemClick(children)}
                                                sx={{ pl: 4 }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 40,
                                                        color: children.selected ? 'primary' : 'inherit'
                                                    }}
                                                >
                                                    {children.icon}
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={children.label}
                                                    sx={{
                                                        opacity: openParent ? 1 : 0,
                                                        transition: 'opacity 0.2s',
                                                    }}
                                                />
                                            </ListItemButton>
                                        ))}
                                    </List>
                                </Collapse>
                            </Box>
                        ))}
            </List>

            <Divider />

            <Box sx={{ p: 2 }}>
                <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    startIcon={openParent ? <HelpCircle size={20} /> : null}
                    sx={{ justifyContent: openParent ? 'flex-start' : 'center', py: 1, minWidth: 0 }}
                >
                    {openParent ? (
                        <Box
                            component="span"
                            sx={{
                                opacity: 1,
                                width: 'auto',
                                overflow: 'hidden',
                                transition: 'opacity 0.2s, width 0.2s',
                            }}
                        >
                            Ajuda e Suporte
                        </Box>
                    ) : (
                        <HelpCircle size={20} />
                    )}
                </Button>
            </Box>
        </Box>
    )

    return (
        <Box
            component="nav"
            sx={{ width: { md: openParent ? drawerWidth : collapsedWidth }, flexShrink: { md: 0 } }}
        >
            {/* Mobile drawer */}
            <Drawer
                variant="temporary"
                open={openParent}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile
                }}
                sx={{
                    display: { xs: 'block', md: 'none' },
                    '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                {drawer}
            </Drawer>

            {/* Desktop drawer */}
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', md: 'block' },
                    '& .MuiDrawer-paper': {
                        width: openParent ? drawerWidth : collapsedWidth,
                        boxSizing: 'border-box',
                        borderRight: `1px solid ${theme.palette.divider}`,
                        overflowX: 'hidden',
                        transition: theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.leavingScreen,
                        }),
                    },
                }}
            >
                {drawer}
            </Drawer>
        </Box>
    )
};
